import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function BadgeCarousel({ className }) {
  const Badges = () => {
    return (
      <>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/most-implementable-logo.svg"
            alt="Most implementable logo"
            width="143"
            height="143"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/roi-winter-logo.svg"
            alt="Roi winter logo"
            width="143"
            height="143"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/leader-winter-logo.svg"
            alt="Leader winter logo"
            width="143"
            height="143"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/capterra-logo.svg"
            alt="Capterra logo"
            width="142"
            height="118"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/get-app-logo.png"
            alt="Getapp logo"
            width="143"
            height="110"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/front-runners-logo-2x.png"
            alt="Front runnerslogo"
            width="136"
            height="142"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/trustpilot-logo.svg"
            alt="Trustpilot logo"
            width="143"
            height="143"
            loading="lazy"
          />
        </li>
        <li className="carousel-item">
          <img
            src="https://assets.setmore.com/website/v2/images/mission/new/crozdesk-calendar-logo.svg"
            alt="Crozdesk calendar logo"
            width="143"
            height="143"
            loading="lazy"
          />
        </li>
      </>
    );
  };
  return (
    <>
      <div className="carousel-cont">
        <ul className={`carousel fx badges-strip ${className}`}>
          <Badges />
        </ul>
        <style global jsx>
          {`
            .carousel-cont {
              overflow: hidden;
              padding: 10px 0;
            }
            @media (max-width: ${viewport.tablet.sm}) {
              .carousel-cont {
                overflow-x: auto;
              }
            }
            .badges-strip .carousel-item {
              min-width: 200px !important;
              width: 200px;
              height: 200px;
              box-shadow: none;
              padding: 20px 30px 20px 30px;
              opacity: 0.5;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .badges-strip {
              gap: 64px !important;
              width: 2400px;
              align-items: center;
              padding: 0 35px;
              display: flex;
              justify-content: space-between;
              margin-left: auto;
              margin-right: auto;
              max-width: 1300px;
              width: 100%;
            }
            .badges-strip li {
              line-height: 0px;
            }
            @media (min-width: ${viewport.tablet.sm}) {
              .badges-strip li:nth-child(4) {
                box-shadow: 0 1px 2px 0 rgb(48 58 71 / 20%),
                  0 1px 3px 0 rgb(48 58 71 / 10%);
                background-color: ${colors.primitive.white.default};
                border-radius: 14.3px;
                opacity: 1;
              }
            }
            @media (max-width: ${viewport.tablet.sm}) {
              .badges-strip {
                gap: 20px !important;
                min-height: initial;
                padding: 0 140px;
                width: 2000px;
              }
              .badges-strip li:nth-child(2) {
                box-shadow: 0 1px 2px 0 rgb(48 58 71 / 20%),
                  0 1px 3px 0 rgb(48 58 71 / 10%);
                background-color: ${colors.primitive.white.default};
                border-radius: 14.3px;
                opacity: 1;
              }
            }
          `}
        </style>
      </div>
    </>
  );
}
